export default function ({values}) {
    if (!values) {
        return <></>
    }

    return values?.map(v => <span key={v} className="m-1 badge bg-primary">{v}</span>);
}